import { isArray, isEmpty } from 'lodash'

export const transformArrayToPaginationFormat = payload => {
  if (isArray(payload)) {
    return {
      content: payload,
      meta: { exactMatch: undefined },
      first: true,
      last: true,
      number: 0,
      numberOfElements: payload.length,
      totalElements: payload.length,
      totalPages: 1,
    }
  }

  return payload
}

export const isOwnReducerAction = (entityKey, entities) =>
  // eslint-disable-next-line no-prototype-builtins
  !(!entities || !entities.hasOwnProperty(entityKey) || isEmpty(entities[entityKey]))

export const isOwnRemoveReducerAction = (entityKey, keys) => !(!keys || keys.entity !== entityKey)

export const isOwnListReducerAction = (ownKey, entityKey, listKey) =>
  !(!entityKey || !listKey || (entityKey && ownKey !== entityKey))
